import { createSelector } from "reselect";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

const authorizeUserDomain = state =>
  get(state, "form.AuthorizerForm.values", {});

// ***************************************************************
// ************** authorizeUserForm selectors ******************
// ***************************************************************

export const authorizeUserSelector = createSelector(
  authorizeUserDomain,
  authorizeUser => authorizeUser
);

// ***************************************************************
// *************** authorizeUserForm makeSelect *******************
// ***************************************************************

export const makeSelectAuthorizeUserForm = () => authorizeUserSelector;

export const makeSelectAuthorizerDeliveryPayload = () =>
  createSelector(authorizeUserSelector, formValues => {
    if (isEmpty(formValues)) return {};
    const { dob, is11BHolder, order_id, rEmail, rName, rNric } = formValues;

    const payload = {
      order_id,
      order: {
        doi: dob,
        is11BHolder,
        rEmail,
        rName,
        rNric
      }
    };

    return payload;
  });
